import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJrgroupComponent } from './simple-icons-jrgroup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJrgroupComponent ],
    exports:      [ SimpleIconsJrgroupComponent ],
    bootstrap:    []
})
export class SimpleIconsJrgroupModule {}
